"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siteConfig = void 0;
exports.storeHref = storeHref;
exports.isStoreAvailable = isStoreAvailable;
/**
 * Public site configuration.
 * Store URLs and company address are left empty until verified values are available.
 */
exports.siteConfig = {
    brandName: "Vos Sumás",
    companyLegalName: "Panda Net SRL",
    entityType: "Sociedad de responsabilidad limitada (SRL)",
    /** From Privacy Policy PDF — do not invent an address. Leave empty until D-U-N-S match is confirmed. */
    companyAddress: "",
    cuit: "30-71885580-9",
    city: "Ciudad de Buenos Aires",
    country: "Argentina",
    canonicalOrigin: "https://vossumas.com",
    logoPath: "/brand/logo.png",
    emails: {
        administracion: "administracion@vossumas.com",
        contacto: "contacto@vossumas.com",
        info: "info@vossumas.com",
    },
    /** Empty until apps are publicly available — CTAs use available-soon behavior. */
    googlePlayUrl: "",
    appStoreUrl: "",
    legal: {
        privacyPath: "/privacidad",
        termsPath: "/terminos",
        privacyPdf: "/legal/Politica_Privacidad_Vos_Sumas_definitiva.pdf",
        termsPdf: "/legal/Terminos_y_Condiciones_Vos_Sumas_Definitivo.pdf",
    },
    medals: [
        {
            id: "laurus",
            name: "LAURUS",
            featured: true,
        },
    ],
};
function storeHref(url, fallbackHash) {
    if (fallbackHash === void 0) { fallbackHash = "#disponible-pronto"; }
    return url.trim() ? url : fallbackHash;
}
function isStoreAvailable(url) {
    return Boolean(url.trim());
}
